import React, { memo, useRef, useLayoutEffect } from "react";
import usePrevious from "../Hooks/usePrevious";

// SingleOTPInputComponent is a memoized component for a single OTP input
export function SingleOTPInputComponent(props) {
  // Destructuring props
  const { focus, autoFocus, ...rest } = props;

  // Ref for the input element
  const inputRef = useRef(null);

  // Custom hook to get the previous focus state
  const prevFocus = usePrevious(!!focus);

  // useLayoutEffect to focus and select the input when focus changes
  useLayoutEffect(() => {
    if (inputRef.current) {
      // Focus the input if it should be focused
      if (focus && autoFocus && focus !== prevFocus) {
        inputRef.current.focus();
        inputRef.current.select();
      }
    }
  }, [autoFocus, focus, prevFocus]);

  // Rendering the input element
  return <input type={"number"} required ref={inputRef} {...rest} />;
}

// Memoized SingleOTPInput component for performance optimization
const SingleOTPInput = memo(SingleOTPInputComponent);
export default SingleOTPInput;
